import { NgModule, APP_INITIALIZER } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from './components/shared/shared-components/shared-components.module';
import { HttpClientModule } from '@angular/common/http';
import { MarkdownModule } from 'ngx-markdown';
import { NgxPaginationModule } from 'ngx-pagination';
import { NotifierModule } from 'angular-notifier';

import {registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { MatDialogModule } from '@angular/material/dialog';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
registerLocaleData(localeFr);


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeDemoTwoComponent } from './components/pages/home-demo-two/home-demo-two.component';
import { HometwoBannerComponent } from './components/pages/home-demo-two/hometwo-banner/hometwo-banner.component';
import { NavbarComponent } from './components/common/navbar/navbar.component';
import { LatestEpisodesComponent } from './components/common/latest-episodes/latest-episodes.component';
import { BlogComponent } from './components/common/blog/blog.component';
import { FooterComponent } from './components/common/footer/footer.component';
import { MostPopularComponent } from './components/common/most-popular/most-popular.component';
import { OurHostsComponent } from './components/common/our-hosts/our-hosts.component';
import { SubscribeComponent } from './components/common/subscribe/subscribe.component';
import { SupportOurChannelComponent } from './components/common/support-our-channel/support-our-channel.component';
import { MustWatchEpisodesComponent } from './components/common/must-watch-episodes/must-watch-episodes.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { TermsOfServicePageComponent } from './components/pages/terms-of-service-page/terms-of-service-page.component';
import { PrivacyPolicyPageComponent } from './components/pages/privacy-policy-page/privacy-policy-page.component';
import { OurHostsPageComponent } from './components/pages/our-hosts-page/our-hosts-page.component';
import { AboutPageComponent } from './components/pages/about-page/about-page.component';
import { BlogPageComponent } from './components/pages/blog-page/blog-page.component';
import { BlogDetailsPageComponent } from './components/pages/blog-details-page/blog-details-page.component';
import { SignInPageComponent } from './components/pages/sign-in-page/sign-in-page.component';
import { SignUpPageComponent } from './components/pages/sign-up-page/sign-up-page.component';
import { AfroTechConnectComponent } from './components/pages/afrotech-connect/afrotech-connect.component';
import { AfroTechConnectBannerComponent } from './components/pages/afrotech-connect/afrotech-connect-banner/afrotech-connect-banner.component';
import { CommentsComponent } from './components/common/comments/comments.component';
import { CommentsService } from './components/common/comments/comments.service';
import { CommentComponent } from './components/common/comment/comment.component';
import { CommentFormComponent } from './components/common/comment-form/comment-form.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ShareSocialMediaModalComponent } from './components/common/share-social-media-modal/share-social-media-modal.component';
import { LatestTalentComponent } from './components/common/latest-talent/latest-talent.component';
import { SignInModalComponent } from './components/common/sign-in-modal/sign-in-modal.component';
import { RecommendedArticlesComponent } from './components/common/recommended-articles/recommended-articles.component';
import { AfrobotComponent } from './components/common/afrobot/afrobot.component';
import { ConfirmEmailComponent } from './components/common/confirm-email/confirm-email.component';
import { ResetPasswordRequestComponent } from './components/common/reset-password-request/reset-password-request.component';
import { ResetPasswordComponent } from './components/common/reset-password/reset-password.component';
import { YoutubeLazyComponent } from './components/common/youtube-lazy/youtube-lazy.component';
import { GoogleAnalyticsService, initializeGoogleAnalytics } from './google-analytics.service';
import { CookieConsentComponent } from './components/common/cookie-consent/cookie-consent.component';
import { LatestArticlesModule } from './components/common/latest-articles/latest-articles.module';
//import { SharedDirectivesModule } from './components/shared/directives/shared-directives/shared-directives.module';

registerLocaleData(localeFr, 'fr');

@NgModule({
	declarations: [
		CookieConsentComponent,
		AppComponent,
		BlogPageComponent,
		HomeDemoTwoComponent,
		HometwoBannerComponent,
		NavbarComponent,
		LatestEpisodesComponent,
		BlogComponent,
		FooterComponent,
		MostPopularComponent,
		OurHostsComponent,
		SubscribeComponent,
		SupportOurChannelComponent,
  		MustWatchEpisodesComponent,
		NotFoundComponent,
		TermsOfServicePageComponent,
		PrivacyPolicyPageComponent,
		OurHostsPageComponent,
		AboutPageComponent,
		BlogDetailsPageComponent,
		SignInPageComponent,
		SignUpPageComponent,
		AfroTechConnectComponent,
		AfroTechConnectBannerComponent,
		CommentsComponent,
		CommentComponent,
		CommentFormComponent,
		ShareSocialMediaModalComponent,
		LatestTalentComponent,
		SignInModalComponent,
		RecommendedArticlesComponent,
		AfrobotComponent,
		ConfirmEmailComponent,
		ResetPasswordRequestComponent,
		ResetPasswordComponent,
		YoutubeLazyComponent,
	],
	imports: [
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        AppRoutingModule,
		SharedComponentsModule,
        BrowserAnimationsModule,
        CarouselModule,
        FormsModule,
		MatDialogModule,
		NotifierModule,
        ReactiveFormsModule,
		CommonModule,
		RouterModule,
		AccordionModule.forRoot(),
		NgxPaginationModule,
		MarkdownModule.forRoot(),
		HttpClientModule,
		NgxPaginationModule,
		ShareButtonsModule,
 		ShareIconsModule,
		LatestArticlesModule,
		//SharedDirectivesModule
	],
	providers: [
		{ provide: LOCALE_ID, useValue: 'fr' },
		CommentsService,
		{
			provide: APP_INITIALIZER,
			useFactory: initializeGoogleAnalytics,
			deps: [GoogleAnalyticsService],
			multi: true
		}
	],
	bootstrap: [AppComponent],
	exports: [CommentsComponent],
})
export class AppModule { }